import { configureStore } from '@reduxjs/toolkit'

import { chartOverlayReducer } from '@web/entities/chart/models/chart-overlay.slice'
import { chartReducer } from '@web/entities/chart/models/chart.slice'
import { expressBarsReducer } from '@web/entities/chart/models/express-bars.slice'
import { expressMarkersReducer } from '@web/entities/chart/models/express-markers.slice'
import { expressSectionReducer } from '@web/entities/chart/models/express-section.slice'
import { deviceReducer } from '@web/entities/device/model/device.slice'
import { equipmentNodeReducer } from '@web/entities/equipment/model/equipment-node.slice'
import { equipmentReducer } from '@web/entities/equipment/model/equipment.slice'
import { kinematicReducer } from '@web/entities/kinematic'
import { mnemonicReducer } from '@web/entities/mnemonic/model/mnemonic.slice'
import { notificationReducer } from '@web/entities/notification/model/notification.slice'
import { plansReducer } from '@web/entities/plan'
import { reportsReducer } from '@web/entities/report/model/reports.slice'
import { serverSettingsReducer } from '@web/entities/server/model/server.slice'
import { settingsReducer } from '@web/entities/settings'
import { authReducer } from '@web/entities/user/model/auth.slice'
import { integralMachineConclusionReducer } from '@web/features/machine-integral-conclusion/model/integral-machine-conclusion.slice'
import { baseApi } from '@web/shared/infrastructure/api-base-query'

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    device: deviceReducer,
    serverSettings: serverSettingsReducer,
    reports: reportsReducer,
    kinematic: kinematicReducer,
    expressSection: expressSectionReducer,
    expressMarkers: expressMarkersReducer,
    expressBars: expressBarsReducer,
    chart: chartReducer,
    chartOverlay: chartOverlayReducer,
    equipment: equipmentReducer,
    equipmentNode: equipmentNodeReducer,
    mnemonic: mnemonicReducer,
    auth: authReducer,
    notification: notificationReducer,
    plans: plansReducer,
    settings: settingsReducer,
    integralMachineConclusion: integralMachineConclusionReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }).concat(baseApi.middleware)
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
